import React, { useState, useEffect } from 'react';
import { Table, TableBody, Grid, TableCell, TableContainer, MenuItem, TableRow, Paper, Tooltip, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import AddEncuesta from './AddEncuesta';
import { useAccesos } from '../contexts/AccesosContext';

function GestionEncuesta() {

    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [encuestas, setEncuestas] = useState([]);
    const [editEncuesta, setEditEncuesta] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [encuestaToDelete, setEncuestaToDelete] = useState(null);
    const [estados, setEstados] = useState([]);
    const [areas, setAreas] = useState([]);
    const [areaFiltro, setAreaFiltro] = useState('');
    const { user } = useUser();   
    const { tienePermiso } = useAccesos();
   

     const fetchAreas = async () => {
                try {
                    const response = await fetch(`${server}/CrmAreaEncuestums`);
                    const data = await response.json();
                    setAreas(data.$values);
                   
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al cargar las Áreas: ' + error,
                    });
                }
            };
            
    const fetchEncuestas = async (idAreaEncuesta = '') => {
        try {
            const url = idAreaEncuesta
            ? `${server}/CrmEncuestums/poridArea/${idAreaEncuesta}`
            : `${server}/CrmEncuestums`;

            const response = await fetch(url);
            const data = await response.json();
            setEncuestas(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: ' Error',
                text: 'Error al cargar las Encuestas: ' + error,
            });
        }
    };
        
            const handleAreaFiltroChange = (event) => {
                setAreaFiltro(event.target.value);
            };

            useEffect(() => {
            fetchAreas();
            fetchEncuestas(); // por defecto todas
            }, []);

            useEffect(() => {
            fetchEncuestas(areaFiltro);
            }, [areaFiltro]);
        
            const handleNewEncuesta = () => {
                fetchEncuestas(areaFiltro)
                setEditEncuesta(null);
            };

                    
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (encuesta) => {
                setEncuestaToDelete(encuesta);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setEncuestaToDelete(null);
            };
        
            const handleDeleteEncuesta = async () => {
                if (encuestaToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmEncuestums/${encuestaToDelete.idEncuesta}/${username}`,
                             {
                            method: 'DELETE'
                        });
                        if (response.ok) {
                            handleCloseDialog();
                            fetchEncuestas(); // Recargar la lista de campanias
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Encuesta eliminada con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar la encuesta:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar la encuesta: ' + error,
                        });            }
                }
            };
        
            const filteredEncuesta = encuestas.filter(encuesta => encuesta.titulo?.toLowerCase().includes(searchQuery.toLowerCase()));
    
    const handleCancelarEdicion = () => {
        setEditEncuesta(null);
    };

return (
<>
    <div className="x_title"></div>
        <div className="x_content">
        <div className="row">
            
            <br />
            <div className="col-md-10 col-sm-4 offset-md-2">
            <br />
            <br />

            <div className="ln_solid" />

            <h2>Encuestas existentes</h2>

           
            <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
                <Grid item xs={12} sm={8}>
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Encuesta"
                        placeholder="Buscar..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        
                     />
                    
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
               <TextField
                    select
                    fullWidth
                    label="Filtrar por Área"
                    value={areaFiltro}
                    onChange={(e) => setAreaFiltro(e.target.value)}
                    variant="outlined"
                >
                    <MenuItem value="">Todos</MenuItem>
                    {areas.map((area) => (
                        <MenuItem key={area.id} value={area.id}>
                            {area.areaEncuesta}
                        </MenuItem>
                    ))}
                </TextField>
                </Grid>
                
            </Grid>

                <div className="table-responsive">
                <TableContainer component={Paper}>
                    <Table>
                    <TableHead>
                        <TableRow>
                        <TableCell align="right">Acciones</TableCell>
                        <TableCell>Titulo</TableCell>
                        <TableCell>Descripcion</TableCell>
                        {/* <TableCell>Fecha de Inicio</TableCell>
                        <TableCell>Fecha de finalización</TableCell> */}
                        {/* <TableCell>Estado</TableCell> */}
                        {/* <TableCell>Promoción asociada</TableCell> */}
                        <TableCell>Área</TableCell>
                        <TableCell>Activa</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {filteredEncuesta.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((encuesta) => (
                            <TableRow key={encuesta.idEncuesta}>
                            <TableCell align="right">
                                <Button onClick={() => setEditEncuesta(encuesta)} color="primary" disabled={!tienePermiso('Editar Encuesta')}>
                                    Editar
                                </Button>
                                {encuesta.tieneRespuestas ? (
                                 <Tooltip title="No se puede eliminar: la encuesta ya tiene respuestas">
                                    <span>
                                        <Button onClick={() => handleOpenDialog(encuesta)} color="secondary" disabled>
                                            Eliminar
                                        </Button>
                                    </span>
                                </Tooltip>
    
                                ):(
                                <Button
                                    onClick={() => handleOpenDialog(encuesta)}
                                    color="secondary"
                                    disabled={!tienePermiso('Eliminar Encuesta')}
                                    >
                                    Eliminar
                                    </Button>
                                )}
                                 </TableCell>
                            <TableCell component="th" scope="row">
                                {encuesta.titulo}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {encuesta.descripcion}
                            </TableCell>
                            <TableCell component="th" scope="row">
                                {encuesta.areaEncuesta}
                            </TableCell>
                            {<TableCell component="th" scope="row">
                                <span style={{
                                    padding: '4px 8px',
                                    borderRadius: '5px',
                                    color: 'white',
                                    background:
                                    encuesta.activa ? 'green' : 'red'
                                }}>
                                {encuesta.activa ? 'Si' : 'No'}
                                </span>
                            </TableCell>
                            }
                            </TableRow>
                           ))}                        
                    </TableBody>
                    </Table>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={encuestas.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRateChange={handleChangeRowsPerPage}
                    />
                </TableContainer>
            </div>
            </div>
                <div className="col-md-9 col-sm-4 offset-md-2">
                 <AddEncuesta handleNewEncuesta={handleNewEncuesta} editEncuesta={editEncuesta} cancelarEdicion={handleCancelarEdicion}/>
                </div>

                <Dialog open={openDialog}
                                                onClose={handleCloseDialog}
                                                aria-labelledby="alert-dialog-title"
                                                aria-describedby="alert-dialog-description">
                                                <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                                                <DialogContent>
                                                    <DialogContentText id="alert-dialog-description">
                                                        ¿Estás seguro de que quieres eliminar esta encuesta?
                                                    </DialogContentText>
                                                </DialogContent>
                                                <DialogActions>
                                                    <Button onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                                    <Button onClick={handleDeleteEncuesta} color="primary" autoFocus>Eliminar</Button>
                                                </DialogActions>
                                            </Dialog>
            </div>
        </div>
    </>

     
    );
}

export default GestionEncuesta;